import BestPractice from './BestPractice'

export default BestPractice
